var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrawing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uADF8\\uB8F9 169",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wt29hpazta"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 482",
    style: {
      fill: "none"
    },
    d: "M0 0h20v24H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 168",
    style: {
      clipPath: "url(#wt29hpazta)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 77",
    d: "m11.739.147.1.035a1.637 1.637 0 0 0 .247.124 9.647 9.647 0 0 1 3.392 1.852 9.735 9.735 0 0 1 3.537 8.208 9.878 9.878 0 0 1-.42 2.261 9.676 9.676 0 0 1-3.946 5.239 22.289 22.289 0 0 1-1.993 1.071l-.193-1.316a8.026 8.026 0 0 0 1.04-.387c.491-.26.951-.577 1.424-.87l.621-.518a.87.87 0 0 0 .207-.136c.407-.485.808-.975 1.211-1.464l.373-.654c.1-.216.214-.429.308-.648a7.379 7.379 0 0 0 .6-2.87 12.38 12.38 0 0 0-.092-1.409 6.891 6.891 0 0 0-.811-2.525l-.374-.655a8.107 8.107 0 0 0-2.676-2.578 7.359 7.359 0 0 0-2.41-.943c-.5-.093-1.007-.149-1.511-.222H9.7c-.453.059-.907.108-1.358.178a7.208 7.208 0 0 0-2.512.947 7.8 7.8 0 0 0-2.046 1.691c-.249.292-.458.618-.685.929l-.386.651c-.091.186-.185.37-.271.557a7.365 7.365 0 0 0-.662 2.986 10.422 10.422 0 0 0 .139 1.609 6.562 6.562 0 0 0 .8 2.306l.386.651A7.647 7.647 0 0 0 5 16.314a9.3 9.3 0 0 0 2.57 1.348l-.244 1.69c-.366-.116-.74-.214-1.1-.352a9.64 9.64 0 0 1-2.37-1.36 9.805 9.805 0 0 1-2.283-2.506A9.741 9.741 0 0 1 .215 11.82a8.731 8.731 0 0 1-.2-2.4 10.106 10.106 0 0 1 .938-3.7A9.817 9.817 0 0 1 6.024.822 12.942 12.942 0 0 1 8.52.1c.216-.045.437-.066.656-.1h1.709l.453.093.262.056h.138",
    transform: "translate(-.001)",
    style: {
      fill: "#0d90db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 78",
    d: "M56.511 355.677h2.414c.157 0 .314.016.471.024a2.082 2.082 0 0 1 .135.43c.023.239 0 .483.009.724a.683.683 0 0 1-.193.574h-12.82a.414.414 0 0 1-.207-.407c.011-.312 0-.625 0-.937s.1-.406.414-.407h8.694a.78.78 0 0 0 .116-.017l.8.014z",
    transform: "translate(-43.382 -333.432)",
    style: {
      fill: "#0c90db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 79",
    d: "M251.7 357.953a.684.684 0 0 0 .193-.574c-.014-.241.013-.484-.009-.723a2.083 2.083 0 0 0-.135-.43c.26 0 .521 0 .781-.009a.287.287 0 0 1 .331.286 9.1 9.1 0 0 1 0 1.12c-.008.114-.137.22-.21.33z",
    transform: "translate(-235.73 -333.953)",
    style: {
      fill: "#0074d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 80",
    d: "M114.8 203.041a.78.78 0 0 1-.116.017h-4.91l-.189-.032.165-1.281q.1-.789.209-1.578l.244-1.69c.062-.425.128-.849.185-1.275.036-.274.057-.55.085-.824l.255-1.65a.571.571 0 0 0 .038-.13 1.884 1.884 0 0 1 1.472-1.729.747.747 0 0 0 .082.042 1.79 1.79 0 0 1 1.165 1.172 7.6 7.6 0 0 1 .19 1.1q.164 1.1.319 2.207c.086.606.165 1.213.251 1.818q.157 1.116.32 2.23l.236 1.608m-2.041-8.768a.756.756 0 0 0-.8 1.117.71.71 0 0 0 .737.421.77.77 0 0 0 .06-1.537",
    transform: "translate(-102.639 -180.812)",
    style: {
      fill: "#ffc433"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 81",
    d: "m109.42 355.379.189.032h-.2a.038.038 0 0 1 .011-.033",
    transform: "translate(-102.468 -333.168)",
    style: {
      fill: "#8eab82"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 82",
    d: "M187.4 21.677a22.258 22.258 0 0 0 1.993-1.071 9.676 9.676 0 0 0 3.946-5.239 9.878 9.878 0 0 0 .42-2.261 9.735 9.735 0 0 0-3.537-8.206 9.646 9.646 0 0 0-3.392-1.852 1.639 1.639 0 0 1-.247-.124c.625.172 1.26.315 1.873.521a8.8 8.8 0 0 1 2.807 1.655 9.575 9.575 0 0 1 2.115 2.49 9 9 0 0 1 1.1 2.7 12.174 12.174 0 0 1 .214 1.385 11.782 11.782 0 0 1 .049 1.372 9.068 9.068 0 0 1-.713 3.294 9.619 9.619 0 0 1-1.226 2.137 10.086 10.086 0 0 1-2.831 2.555 9.964 9.964 0 0 1-2.494 1.077l-.081-.431",
    transform: "translate(-174.748 -2.739)",
    style: {
      fill: "#0175d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 83",
    d: "m154.452 199.022.081.431.228 1.706.152 1.137-.147.032-.8-.014c-.079-.536-.159-1.072-.236-1.608l-.32-2.23c-.085-.606-.165-1.213-.251-1.819q-.156-1.1-.319-2.207a7.6 7.6 0 0 0-.19-1.1 1.79 1.79 0 0 0-1.165-1.172.755.755 0 0 1-.082-.042l.1-.048.664.033a1.787 1.787 0 0 1 1.325.935 4.542 4.542 0 0 1 .334 1.545c.087.5.14 1 .21 1.507.074.532.151 1.064.227 1.6l.193 1.316",
    transform: "translate(-141.799 -180.084)",
    style: {
      fill: "#ffb323"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 84",
    d: "m204.41 355.411.147-.032a.048.048 0 0 1 .016.033h-.163",
    transform: "translate(-191.444 -333.168)",
    style: {
      fill: "#8eab82"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 85",
    d: "M183.01 2.357",
    transform: "translate(-171.272 -2.21)",
    style: {
      fill: "#0175d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 86",
    d: "m50.41 38.2-.664-.033v-1.51a2.016 2.016 0 0 0-.194.08q-.839.476-1.677.954-1.615.92-3.229 1.842c-.5.288-1 .585-1.5.878l-.386-.651c.435-.234.875-.461 1.3-.7.856-.482 1.706-.974 2.56-1.461s1.695-.963 2.542-1.445c.139-.079.137-.161 0-.24l-2.214-1.259c-1-.568-1.993-1.138-2.992-1.7-.4-.223-.8-.433-1.2-.648l.386-.651c.809.469 1.615.94 2.426 1.405q1.483.851 2.971 1.693l1.155.656v-4.509a2.257 2.257 0 0 0 .03-.249c.006-.5.008-1.01.011-1.515q0-.613.006-1.226h.668q0 .613.006 1.226V35.359l.083.039.808-.5 1.43-.8.48-.289a1.509 1.509 0 0 0 .2-.078c.735-.416 1.471-.832 2.2-1.254.467-.269.928-.548 1.392-.822l.374.655a2.911 2.911 0 0 0-.278.123q-1.469.836-2.933 1.678c-.187.108-.358.24-.537.362a1.408 1.408 0 0 0-.281.09q-.637.361-1.265.739c-.139.084-.263.191-.393.287l-.9.417c.092.066.121.091.154.11q1.175.675 2.351 1.348 1.442.825 2.886 1.647c.4.224.8.436 1.2.653l-.373.654a.425.425 0 0 0-.081-.082c-.423-.242-.847-.481-1.27-.722l-4.565-2.6c-.206-.117-.419-.222-.681-.36z",
    transform: "translate(-40.046 -26.165)",
    style: {
      fill: "#e7e2e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 87",
    d: "M216.934 227.432a1.285 1.285 0 0 1-.957-.1 3.45 3.45 0 0 1-.284-.226 1.846 1.846 0 0 1 .19-.073 1.123 1.123 0 0 0 .9-1.308 3.544 3.544 0 0 0-.185-.585 1.131 1.131 0 0 1 1.05.813 1.232 1.232 0 0 1-.1.963l-.621.518",
    transform: "translate(-202.01 -211.068)",
    style: {
      fill: "#eb2929"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 88",
    d: "M100.491 216.837a4.87 4.87 0 0 1-.754.179.911.911 0 0 1-.81-.362 1.014 1.014 0 0 1 .148-.052 1.079 1.079 0 0 0 .944-1.132c-.041-.262-.121-.519-.183-.778a1.271 1.271 0 0 1 .909.494l-.255 1.65",
    transform: "translate(-92.652 -201.275)",
    style: {
      fill: "#01cb32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 89",
    d: "M147.854 215.366a.77.77 0 0 1-.06 1.537.71.71 0 0 1-.737-.421.793.793 0 0 0 .8-1.117",
    transform: "translate(-137.729 -201.905)",
    style: {
      fill: "#f0eeee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 90",
    d: "M146.21 215.069a.793.793 0 0 1-.8 1.117.756.756 0 0 1 .8-1.117",
    transform: "translate(-136.085 -201.608)",
    style: {
      fill: "#faf7f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 91",
    d: "M185.589 132.859a1.193 1.193 0 0 1-1.009 1.381 1.13 1.13 0 0 1-.93-.265c.131-.1.255-.2.393-.287q.627-.378 1.265-.739a1.407 1.407 0 0 1 .281-.09",
    transform: "translate(-172.002 -124.555)",
    style: {
      fill: "#0275d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 92",
    d: "M163.491 47.533a1.028 1.028 0 0 1 .805.956 1.109 1.109 0 0 1-.551 1.132 1.2 1.2 0 0 1-.255.08v-2.169",
    transform: "translate(-153.121 -44.562)",
    style: {
      fill: "#01cb32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 93",
    d: "M139.547 49.338a.962.962 0 0 1-.252-.992 1.018 1.018 0 0 1 .812-.819c0 .505 0 1.01-.011 1.515a2.256 2.256 0 0 1-.03.249z",
    transform: "translate(-130.416 -44.557)",
    style: {
      fill: "#3ed359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 94",
    d: "M176.929 119.162a1.134 1.134 0 0 1 1.191-1.366l.24.563-1.43.8",
    transform: "translate(-165.667 -110.429)",
    style: {
      fill: "#0e91db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 95",
    d: "m196.551 118.41-.24-.563a.929.929 0 0 1 .719.273l-.48.289",
    transform: "translate(-183.859 -110.48)",
    style: {
      fill: "#0275d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 96",
    d: "m143.945 75.8.52-.047v.421a.749.749 0 0 1-.52-.374",
    transform: "translate(-134.814 -71.015)",
    style: {
      fill: "#01cb32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 97",
    d: "M58.7 138.77a1.139 1.139 0 0 1 1.147 1.086 1.18 1.18 0 0 1-1.128 1.236 1.058 1.058 0 0 1-.926-.4 2.787 2.787 0 0 0 .354-.088 1.166 1.166 0 0 0 .552-1.83",
    transform: "translate(-54.123 -130.091)",
    style: {
      fill: "#eb2929"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 98",
    d: "M53.984 138.79a1.166 1.166 0 0 1-.552 1.83 2.789 2.789 0 0 1-.354.088 1.1 1.1 0 0 1-.049-1.491 1 1 0 0 1 .956-.427",
    transform: "translate(-49.411 -130.111)",
    style: {
      fill: "#ff4242"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 99",
    d: "M93.036 65.342a1.077 1.077 0 0 1 1.1 1.034 1.14 1.14 0 0 1-1.113 1.286.971.971 0 0 1-.9-.392c.032-.019.064-.054.1-.055a1.143 1.143 0 0 0 .892-1.68 1.73 1.73 0 0 1-.078-.192",
    transform: "translate(-86.281 -61.258)",
    style: {
      fill: "#ffb423"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 100",
    d: "M88.112 65.182a1.728 1.728 0 0 0 .078.192 1.143 1.143 0 0 1-.892 1.68c-.032 0-.065.036-.1.055a1.108 1.108 0 0 1-.236-1.252 1.126 1.126 0 0 1 1.147-.676",
    transform: "translate(-81.358 -61.098)",
    style: {
      fill: "#ffc433"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 101",
    d: "M236.083 147.132a1.126 1.126 0 0 1 1.053.716 1.1 1.1 0 0 1-.172 1.177 1.187 1.187 0 0 1-1.788.071.729.729 0 0 1 .125-.051 1.184 1.184 0 0 0 .988-.916 1.371 1.371 0 0 0-.206-1",
    transform: "translate(-220.259 -137.936)",
    style: {
      fill: "#ffb423"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 102",
    d: "M231.192 147.132a1.372 1.372 0 0 1 .206 1 1.184 1.184 0 0 1-.988.916.729.729 0 0 0-.125.051 1.117 1.117 0 0 1-.018-1.569 1.176 1.176 0 0 1 .925-.4",
    transform: "translate(-215.368 -137.936)",
    style: {
      fill: "#ffc433"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 103",
    d: "M198.632 63.838a1.123 1.123 0 0 1 1.138 1.017 1.164 1.164 0 0 1-1.135 1.308.961.961 0 0 1-.862-.361 1.7 1.7 0 0 0 .227-.1 2.482 2.482 0 0 0 .621-.423 1.125 1.125 0 0 0 .011-1.438",
    transform: "translate(-185.228 -59.846)",
    style: {
      fill: "#eb2929"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 104",
    d: "M193.164 63.839a1.125 1.125 0 0 1-.011 1.438 2.481 2.481 0 0 1-.621.423 1.691 1.691 0 0 1-.227.1 1.072 1.072 0 0 1-.255-1.281 1.1 1.1 0 0 1 1.113-.682",
    transform: "translate(-179.76 -59.847)",
    style: {
      fill: "#ff4242"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 105",
    d: "M94.91 214.693c.062.259.142.516.183.778a1.079 1.079 0 0 1-.944 1.132 1.013 1.013 0 0 0-.148.052 1.133 1.133 0 0 1-.236-1.259 1.226 1.226 0 0 1 1.146-.7",
    transform: "translate(-87.725 -201.275)",
    style: {
      fill: "#3dd358"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 106",
    d: "M211.4 225.14a3.547 3.547 0 0 1 .185.585 1.123 1.123 0 0 1-.9 1.308 1.853 1.853 0 0 0-.19.073 1.038 1.038 0 0 1-.3-1.105 1.08 1.08 0 0 1 .891-.822c.106-.017.213-.026.32-.039",
    transform: "translate(-196.813 -211.069)",
    style: {
      fill: "#ff4242"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawing);
export default __webpack_public_path__ + "static/media/drawing.de345504fc97a3d332216dc7269a2200.svg";
export { ForwardRef as ReactComponent };